import Vue from "vue";
import { ref, query, get } from "firebase/database";
import { doc, getDoc } from "firebase/firestore";

import { database, firestore } from "@/common/firebase";

import { ObjectToSortedArray, createModuleResetter } from "@/helpers/utils";

import { FETCH, GET } from "../../actions";
import { SET_ITEM, RESET_STORE } from "../../mutations";

const getInitState = () => ({
  items: {},
});

const getters = {
  itemsSorted: (state) => {
    return ObjectToSortedArray(state.items, "createdAt");
  },

  itemById: (state) => ({ id }) => {
    return state.items[id];
  },
};

const mutations = {
  [SET_ITEM](state, { key, value }) {
    Vue.set(state.items, key, value);
  },

  [RESET_STORE]: createModuleResetter(getInitState),
};

const actions = {
  async [FETCH]({ commit }, payload) {
    const { country = "france" } = payload;
    const resultRef = query(ref(database, `index/resources/${country}`));

    const snapshot = await get(resultRef);
    const data = snapshot.val();

    for (const key in data) {
      commit(SET_ITEM, { key, value: data[key] });
    }

    return data;
  },
  async [GET](_, payload) {
    const { country = "france", id } = payload;

    console.log("country", country);
    console.log("id", id);
    const resultRef = query(ref(database, `resources/${country}/${id}`));

    const snapshot = await get(resultRef);
    const data = snapshot.val();

    const docRef = doc(firestore, `/resources/resources/${country}/${id}`);
    const docSnapshot = await getDoc(docRef);

    return { ...data, ...docSnapshot.data() };
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  actions,
  mutations,
  getters,
};
